import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import RootStore from 'store/RootStore';

interface IUsePicPay {
    rootStore?:RootStore;
    currentPayGood?:any;
    list:any[];
    index:number;
}

const usePicPay = (props:IUsePicPay) => {
    const {currentPayGood, list, index} = props;
    const {wxuserStore, pagedataStore} = props.rootStore!;
    const {currentPayedImages} = wxuserStore;

    const image = list[index];

    // 需要发送请求并检查
    useEffect(()=>{
        const checkGallery = async (galleryId:string|number)=>{
            let exist = pagedataStore.currentGallerys[String(galleryId)];
            if(!exist) {
                await pagedataStore.getGallerys([String(galleryId)]);
                exist = pagedataStore.currentGallerys[String(galleryId)]
            }

            return exist;
        };

        const checkGood = async (goodId:string|number)=>{
            let exist = wxuserStore.currentPayGood[String(goodId)];
            if(!exist) {
                await wxuserStore.getCurrentPayGood(goodId);
                exist = wxuserStore.currentPayGood[String(goodId)];
            }

            return exist;
        } 

        const init = async ()=>{
            // 还是保守一点吧，看看当前相册有没有开通付费
            const currentGallery = window.dataDetail ? window.dataDetail : window.gallery;
            if(currentGallery && Number(currentGallery.is_pay_down) > 0) {
                if(!currentPayGood && image && image.galleryid) {
                    let exist = await checkGallery(image.galleryid);
                    if(exist && exist.is_pay_down) {
                        await checkGood(exist.is_pay_down);
                    }
                }
            }
        };

        init();
    }, [currentPayGood]);

    const getCurrentPayGood = ()=>{
        if(image && image.galleryid) {
            let exist = pagedataStore.currentGallerys[String(image.galleryid)];
            if(exist) {
                return wxuserStore.currentPayGood[String(exist.is_pay_down)];
            }
        }

        return null;
    };

    const good = currentPayGood ? currentPayGood : getCurrentPayGood();

    const checkCurrentIndexIsPayed = ()=>{
        const currentImage = list[index];
        if(currentImage && currentImage.id) {
            return currentPayedImages[String(currentImage.id)] ? true : false;
        }

        return false;
    };

    const checkCurrentPayWatermark = ()=>{
        if(good && good.type == 'remove_watermark') {
            if(good.ext && good.ext.watermark) {
                return good.ext.watermark;
            }
        }
        else if(good && good.type == 'download_photo') {
            // 直接返回一张锁定图
            return 'attachment/358ba6ab32bccdea8ddd60272fc1ae22.png';
        }

        return '';
    };

    const checkCurrentPayId = ()=>{
        if(good && good.id) {
            return good.id;
        }

        return 0;
    }

    return {
        currentIndexIsPayed:checkCurrentIndexIsPayed(),
        currentPayWatermark:checkCurrentPayWatermark(),
        currentPayId:checkCurrentPayId()
    };
};

export default usePicPay;